import script from "./MSR_SO_004.vue?vue&type=script&setup=true&lang=js"
export * from "./MSR_SO_004.vue?vue&type=script&setup=true&lang=js"

import "./MSR_SO_004.vue?vue&type=style&index=0&id=0af150f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0af150f2"]])

export default __exports__